import React, { useState, useEffect, useRef } from "react";
import "./libro.css";

export const Libro = ({ identificador = [], value = null,showRegistro=null }) => {

    const [libro, setLibro] = useState(value);
    const aa = [];
    aa[identificador] = useRef();

    const setRotate = (val, value) => {
        const div = val.current;
        div.className = value ? "book-wrap rotate" : "book-wrap";
    };

    useEffect(() => {
        setLibro(value);
    }, [value]);

    return (
        <div className="wrap">
            <div className="perspective">
                <div ref={aa[identificador]} className="book-wrap">
                    <div className="book book-1" onClick={() =>showRegistro(libro)} onMouseEnter={() => setRotate(aa[identificador], true)} onMouseLeave={() => setRotate(aa[identificador], false)}>
                        <div className="title-content">
                            <div className="title-content1">Libro de Clases</div>
                            <div className="title-content2">{libro.nivel+' '+libro.grado}</div>
                        </div>
                    </div>
                    <div className="title book-1"></div>
                </div>
            </div>
        </div>
    );
};
